import type {
  ContainerTypeEligibilityRulesUpdateRequestType,
  ContainerTypeEligibilityRulesUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useContainerTypeEligibilityRulesUpdate = (
  containerTypeEligibilityRulesId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ContainerTypeEligibilityRulesUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `container-type-eligibility-rules/${containerTypeEligibilityRulesId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as ContainerTypeEligibilityRulesUpdateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.FulfillmentType],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentType],
      });
    },
  });
};
